<template>
    <!--    <div class="card mb-6" v-show="displayForSubscriptionPlan('starter')">-->
    <!--            <widget-layout-->
    <!--                :graph-title="'Visits by Date'"-->
    <!--                :graph-type="type"-->
    <!--                :graph-values="values"-->
    <!--                :loading-data="haveData"-->
    <!--                :graph-options="options"-->
    <!--            ></widget-layout>-->
    <!--    </div>-->

    <div class="mb-6" v-show="displayForSubscriptionPlan('starter')">
        <!--            <div class="text-center py-24 lg:py-12 text-gray-500 dark:text-gray-400"> With title</div>-->
        <widget-layout
            :graph-title="'Visits by Date'"
            :graph-type="type"
            :graph-values="values"
            :loading-data="haveData"
            :graph-options="options"
        ></widget-layout>
    </div>
</template>

<script>
import WidgetLayout from "@/Layouts/WidgetLayout";

export default {
    name: "ClicksGraph",
    components: {
        WidgetLayout,
    },
    props: {
        campaignCode: String,
        referrerCode: String,
        range: {
            type: String,
            default: 'daily'
        }
    },
    data() {
        return {
            haveData: false,
            period: '',
            type: 'line',
            values: {
                labels: [],
                datasets: [{
                    label: '',
                    data: [],
                    fill: true,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.1
                }],
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false,
                            drawBorder: false,
                            drawOnChartArea: true,
                            drawTicks: true,
                        }
                    },
                    y: {
                        grid: {
                            drawBorder: false,
                            display: false
                        },
                    }
                }
            }
        }
    },
    methods: {
        fetchReport() {
            axios.get('/sanctum/csrf-cookie').then(response => {
                axios.get(route('report.clicks', {
                    'range': this.range,
                    'campaign_code': this.campaignCode,
                    'referrer_code': this.referrerCode
                })).then((response) => {
                    let data = response.data.data;
                    let labels = data.map((item) => item.date);
                    let values = data.map((item) => item.clicks);
                    this.values.labels = labels;
                    this.values.datasets[0].data = values;
                    this.values.datasets[0].data = values;
                    this.period = data.period;
                    this.haveData = true;
                }).catch(err => console.error(err))
            });
        }
    },
    watch: {
        range: function(newVal, oldVal) { // watch it
            // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.haveData = false;
            this.values.labels = [];
            this.values.datasets[0].data = [];
            this.values.datasets[0].data = [];
            this.fetchReport();
        }
    },
    created() {
        this.fetchReport();
    }
}
</script>

<style scoped>

</style>
